import { BASE_URL } from "../apiConfig";
import apiClient from "../apiInstance";


// Get updaload dates for review
export const fetchDateOfUploadForReview = async () => {
    try {
      const response = await apiClient.get(`${BASE_URL}/getUploadDatesForReview`);
      return response.data;
    } catch (error) {
      console.error('Error fetching rules:', error);
      throw error;
    }
  };

  // Get customers uploaded on a specific date
export const fetchCustomerDatabyUploadDate = async (date, campaignId) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/getCustomersByUploadDate/${date}/${campaignId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching rules:', error);
    throw error;
  }
};

// Update customer checkboxes
export const updateCustomerCheckboxes = async (updatedFields) => {
  try {
    const response = await apiClient.put(`${BASE_URL}/bulkUpdateCustomerCheckboxes`, updatedFields, {
      headers: {
        "Content-Type": "application/json"
      },
    });
    return response.data; // Success response from the backend
  } catch (error) {
    console.error(`Error updating customer :`, error.response?.data || error.message);
    throw error; // Forward the error to be handled in the calling function
  }
};

export const updateCustomerData = async (id, updatedFields) => {
  try {
    const response = await apiClient.put(`${BASE_URL}/updateCustomerData/${id}`, updatedFields, {
      headers: {
        "Content-Type": "application/json"
      },
    });
    return response.data; // Success response from the backend
  } catch (error) {
    console.error(`Error updating customer ${id}:`, error.response?.data || error.message);
    throw error; // Forward the error to be handled in the calling function
  }
};
  